const url = {
    dev: {
        publicUrl: 'https://talin.admin.api.xywh-yuanqi.com',
        manageUrl: 'https://talin.admin.api.xywh-yuanqi.com'

        // publicUrl: 'https://test.api.cxc-group.com/api/admin',
        // manageUrl: 'https://test.api.cxc-group.com/api/admin'
    },
    pro: {
        publicUrl: 'https://admin.api.guotajituan.com',
        manageUrl: 'https://admin.api.guotajituan.com'
    }
}

export const get = () => {
    if(process.env.NODE_ENV === 'production'){
        return url['pro']
    }else{
        return url['dev']
    }
}
